import { createFileRoute } from '@tanstack/react-router'

import LoggerCommands from 'pages/LoggerCommands'

export const Route = createFileRoute('/_auth/_global/commands')({
  component: LoggerCommands,
})
